import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { LogoGroup } from './components/logo/logo-group.tsx';
import { ProfileButton } from './possibly-stateful-components/ProfileButton.tsx';
import { ContactUsButton } from './possibly-stateful-components/ContactUsButton.tsx';
import { PortalNavBar } from './possibly-stateful-components/PortalNavBar/PortalNavBar.tsx';
import { useGetCurrentUser } from '../../hooks/auth.ts';
import { useNavigate } from 'react-router';
import './NavBar.scss';
import imgUrl from '../../assets/IH_LogoWithText.png';

export const Navbar = () => {
  const { data: user } = useGetCurrentUser();
  const [showNavBar, setShowNavBar] = useState(false);
  const navigate = useNavigate();
  const handleNav = (search: string) => {
    void navigate(search);
  };
  const fontSizeText = '.8125rem';
  return (
    <AppBar position="sticky" className="nav-bar-main">
      <Toolbar className="tool-bar">
        <LogoGroup
          user={!!user?.userId || false}
          action={() => setShowNavBar(!showNavBar)}
          href={imgUrl}
        />
        <Box
          sx={{
            display: 'flex',
            gap: '24px',
          }}
          className="navBarLinks"
        >
          <Typography
            sx={{ fontSize: fontSizeText, cursor: 'pointer' }}
            onClick={() => handleNav('/search')}
          >
            FIND YOUR LAND
          </Typography>
          <Typography
            sx={{ fontSize: fontSizeText, cursor: 'pointer' }}
            onClick={() => handleNav('/models')}
          >
            EXPLORE MODELS
          </Typography>
          <Typography sx={{ fontSize: fontSizeText, color: 'inherit' }}>
            <a
              style={{ color: 'inherit' }}
              href="https://www.immersivehomes.com/how-it-works"
              target="_blank"
            >
              HOW IT WORKS
            </a>
          </Typography>
          <Typography sx={{ fontSize: fontSizeText, color: 'inherit' }}>
            <a
              style={{ color: 'inherit' }}
              href="https://www.immersivehomes.com/about-us"
              target="_blank"
            >
              ABOUT US
            </a>
          </Typography>
          <Typography sx={{ fontSize: fontSizeText, color: 'inherit' }}>
            <a
              style={{ color: 'inherit' }}
              href="https://www.immersivehomes.com/contact"
              target="_blank"
            >
              CONTACT US
            </a>
          </Typography>
        </Box>
        <Box
          className="right-side-menu"
          sx={{ display: 'flex', height: '100%' }}
        >
          <ContactUsButton />
          <ProfileButton />
        </Box>
      </Toolbar>
      {user?.userId && (
        <PortalNavBar setShowNavBar={setShowNavBar} showNavBar={showNavBar} />
      )}
    </AppBar>
  );
};
